import React, { useState } from "react";
import pClasses from "../Test.module.scss";
import { useTranslation } from "react-i18next";
// import ButtonsArea from "../../Buttons/ButtonsArea";
// import RoundButton from "../../Buttons/RoundButton";
import Title from "../../Title";
import { useGlobalContext } from '../TestsContext/GlobalStateContext';
import AlertDialogSquare from "../../AlertDialogSquare";

interface TestResultsInterface {
  testTime: number;
  results: number;
  testLevel: number;
  onClick: () => void | null;
  onClickWS: () => void | null;
  setTimeToPass: (newValue: any) => void | null;
}

export default function TestResults({
  testTime,
  results,
  testLevel,
  onClick,
  onClickWS,
  setTimeToPass
}: TestResultsInterface) {
  const { t } = useTranslation();
  let testLevelAux = testLevel;
  const { globalMiscellaneous, setTestTimeGlobal } = useGlobalContext();
  if (globalMiscellaneous.isSSW) testLevelAux = 40;
  const [isAbbleButtonSave, setIsAbbleButtonSave] = useState(false);
  const _milisecondsMiscellaneous = (
    <div className={pClasses.ArrayMiscellaneous}>
      <table>
        <thead>
          <tr>
            <th scope="col"> {globalMiscellaneous.zero + "/10 "} </th>
            <th scope="col"> {globalMiscellaneous.two + "/8 "} </th>
            <th scope="col"> {globalMiscellaneous.five + "/8 "} </th>
            <th scope="col"> {globalMiscellaneous.eight + "/8 "} </th>
            <th scope="col"> {globalMiscellaneous.ten + "/8 "} </th>
            <th scope="col"> {globalMiscellaneous.fifteen + "/8 "}  </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" data-label={globalMiscellaneous.zero + "/10 "}>  0 ms </td>
            <td data-label={globalMiscellaneous.two + "/8 "}>  2 ms </td>
            <td data-label={globalMiscellaneous.five + "/8 "}>  5 ms </td>
            <td data-label={globalMiscellaneous.eight + "/8 "}>  8 ms </td>
            <td data-label={globalMiscellaneous.ten + "/8 "}>  10 ms </td>
            <td data-label={globalMiscellaneous.fifteen + "/8 "}> 15 ms </td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  const _sequencialScore = (
    <div className={pClasses.ArrayMiscellaneous}>
      <table>
        <thead>
          <tr>
            <th scope="col"> {globalMiscellaneous.sswOD + "/10 "} </th>
            <th scope="col"> {globalMiscellaneous.sswOE + "/10 "} </th>
            <th scope="col"> {globalMiscellaneous.sswOEComp + "/10 "} </th>
            <th scope="col"> {globalMiscellaneous.sswODComp + "/10 "} </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" data-label={globalMiscellaneous.sswOD + "/10 "}>  {t('tests.start_right_ear')} </td>
            <td data-label={globalMiscellaneous.sswOE + "/10 "}>  {t('tests.start_left_ear')} </td>
            <td data-label={globalMiscellaneous.sswOEComp + "/10 "}>  {t('tests.start_left_ear_competitive')} </td>
            <td data-label={globalMiscellaneous.sswODComp + "/10 "}>  {t('tests.start_right_ear_competitive')} </td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  const _oeodMiscellaneous = (
    <div className={pClasses.ArrayMiscellaneous}>
      <table>
        <thead>
          <tr>
            <th scope="col"> {globalMiscellaneous.oe + "/5"} </th>
            <th scope="col"> {globalMiscellaneous.od + "/5"} </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" data-label={globalMiscellaneous.oe + "/5"}> Ouvido Esquerdo </td>
            <td data-label={globalMiscellaneous.od + "/5"}> Ouvido Direito </td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  let _content = null as any;

  const time = testTime / 1000;
  let minutes = null as any;
  minutes = Math.floor(time / 60);
  if (minutes === 0) minutes = "00";
  if (minutes < 10 && minutes !== "00") minutes = "0" + minutes;
  let seconds = null as any;
  seconds = Math.floor(time - minutes * 60);
  if (seconds < 10) seconds = "0" + seconds;
  const dataTime = (minutes + ":" + seconds);

  _content = (
    <>
      <div className={pClasses.areaResults}>
        <Title h1 center>
          {t("global.your_result_was")} {results}/{testLevelAux}
        </Title>
        <>
          {globalMiscellaneous.isRT !== null && _milisecondsMiscellaneous}
          {globalMiscellaneous.isOT !== null && _oeodMiscellaneous}
          {globalMiscellaneous.isSSW !== null && _sequencialScore}
        </>
        <Title h1 center>
          {t("global.your_time_was")} {dataTime} {t("global.mm_ss")}
          {setTestTimeGlobal(dataTime)}
        </Title>
      </div>
      <Title light h3></Title>
      <div>{t("global.without_save_message")}</div>
      <br />
      <div className={pClasses.ContentFixedButton}>
        <AlertDialogSquare
          textButton={t("global.cancel")}
          textDialogPrimary={t("global.without_save") + "?"}
          textDialogSecondary={t("tests.chose_confirm_to_go_back_to_tests")}
          onConfirm={onClickWS}
          btnSecondary="true"
        />
        <AlertDialogSquare
          textButton={
            !isAbbleButtonSave ? t("infos.saving") : t("global.processing")
          }
          textDialogPrimary={t("global.go_out_and_save?")}
          textDialogSecondary={t("tests.confirm_go_out_and_save")}
          buttonDesabled={isAbbleButtonSave}
          onConfirm={() => {
            onClick();
            setIsAbbleButtonSave(true);
          }}
        />
      </div>
    </>
  );

  return _content;
}